/* FalcX phone menu drawer. Additive only: Horizon's header-drawer markup and script are not edited (scroll lock, focus
   trap, back handling as shipped). Adds inside the panel: a sticky logo head; a copy of the header's vehicle line
   (snippets/falcx-vehicle-chip.liquid, filled by falcx-finder.js); image cards for ?series= links (falcx-car-* files
   from the vehicle data); "Series · years" titles split in two lines plus a "Saved" mark; the bottom bar from
   <template id="falcx-drawer-extras"> (sections/falcx-shop-by-car.liquid).
   r8: on every open, card sections (top-level items whose child links all go to collections, e.g. "Shop by car" and
   "Shop parts") are expanded, other accordions ("Support") collapsed, scrolled to the top; each opens and closes on
   its own until the drawer closes. Found by links, never by titles or handles. Show/Hide pill on card-section
   headings; aria-expanded follows the open state; Esc anywhere closes the drawer. Without JS: Horizon's drawer.
   r8 sweep: Horizon morphs the header after load, which strips all of this; the panel is watched and enhanced again
   (see watch()). Menu items come from the store menu (falcx-launch-navigation).
   r9 (SEO): series links may be plain hub URLs (/collections/ba-bf-falcon, no ?series=&body=) so crawlers see one URL
   per hub. The series then comes from the link title ("EF–EL · 1994–1998"): it picks the card image, the "Saved" mark,
   and is added to the address only at the moment of the click (seriesHref), never in the HTML. Desktop mega-menu cards
   get data-fx-series and their picture the same way (tagMega). Old ?series= links keep working unchanged.
   r9 (tech, resumed): menu links may also name the series in a fragment, /collections/ea-el-falcon#series=ef-el (the
   crawlable URL is the bare hub; fragments are not separate URLs). Read wherever ?series= is read (paramOf); a click
   turns the fragment into ?series= for that one navigation (seriesHref), which also forces a real page load when the
   visitor is already on that hub (a fragment-only change would not reload). */
(function () {
  'use strict';

  /* ---- Pure helpers (exported for tests/falcx-menu.test.cjs) ---- */
  /* A card section: at least one child link, and every one goes to a collection (query ignored) or names a series. */
  function isCardHref(href) {
    if (!href) return false;
    var u = null;
    try { u = new URL(href, 'https://falcx.invalid'); } catch (e) { return false; }
    if (u.searchParams.has('series') || hashParams(u).has('series')) return true;
    return /\/collections\/[^/]+\/?$/.test(u.pathname);
  }
  function isCardSection(hrefs) {
    if (!hrefs || !hrefs.length) return false;
    for (var i = 0; i < hrefs.length; i++) if (!isCardHref(hrefs[i])) return false;
    return true;
  }
  /* Default state on every open: card sections expanded, everything else collapsed. `sections` are
     { details, hrefs } pairs; only `details.open` is written. Returns how many sections were opened. */
  function applyDefaults(sections) {
    var opened = 0;
    (sections || []).forEach(function (s) {
      var want = isCardSection(s.hrefs);
      if (s.details.open !== want) s.details.open = want;
      if (want) opened++;
    });
    return opened;
  }

  /* r8 mobile sweep: put back the open/closed state the visitor had (`states`, one boolean per section, by position)
     after Horizon's header morph has rewritten the drawer. Sections with no recorded state get the default. */
  function restoreStates(sections, states) {
    (sections || []).forEach(function (s, i) {
      var want = states && typeof states[i] === 'boolean' ? states[i] : isCardSection(s.hrefs);
      if (s.details.open !== want) s.details.open = want;
    });
  }

  /* r9: the series a menu link stands for. ?series= in the link wins; otherwise a plain hub link names it in its title
     ("EA–ED · 1988–1994", "FG X · 2014–2016", "BA–BF Falcon"). The title must name a series of that hub. */
  var SERIES = ['ea-ed', 'ef-el', 'au', 'ba-bf', 'fg', 'fgx'];
  var HUB_OF = { 'ea-ed': 'ea-el-falcon', 'ef-el': 'ea-el-falcon', au: 'au-falcon', 'ba-bf': 'ba-bf-falcon', fg: 'fg-fgx-falcon', fgx: 'fg-fgx-falcon' };
  function urlOf(href) { try { return new URL(href, 'https://falcx.invalid'); } catch (e) { return null; } }
  /* r9: "#series=ef-el&body=ute" as parameters (empty when there is no fragment or it is a plain anchor). */
  function hashParams(u) {
    var h = u && u.hash ? u.hash.replace(/^#/, '') : '';
    try { return new URLSearchParams(/(^|&)(series|body)=/.test(h) ? h : ''); } catch (e) { return { get: function () { return null; }, has: function () { return false; } }; }
  }
  /* A link parameter from the query string, else from the fragment. */
  function paramOf(href, name) {
    var u = href ? urlOf(href) : null;
    if (!u) return null;
    return u.searchParams.get(name) || hashParams(u).get(name) || null;
  }
  /* The hub handle of a plain hub URL (optionally under a /xx or /xx-yy locale prefix), else null. */
  function hubOf(href) {
    var u = href ? urlOf(href) : null;
    var m = u && u.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/(ea-el-falcon|au-falcon|ba-bf-falcon|fg-fgx-falcon)\/?$/);
    return m ? m[1] : null;
  }
  function seriesFromText(text) {
    var t = String(text || '').split(/[·(]/)[0].replace(/falcon/i, '').replace(/[‐-―-]/g, '-').replace(/\s+/g, ' ').trim().toUpperCase();
    var map = { 'EA-ED': 'ea-ed', 'EF-EL': 'ef-el', AU: 'au', 'BA-BF': 'ba-bf', FG: 'fg', 'FG X': 'fgx', FGX: 'fgx', 'FG-X': 'fgx' };
    return map[t.replace(/\s*-\s*/g, '-')] || map[t] || null;
  }
  function seriesOfLink(href, text) {
    var u = href ? urlOf(href) : null;
    if (!u) return null;
    var q = String(paramOf(href, 'series') || '').toLowerCase();
    if (q === 'fg-x') q = 'fgx';
    if (SERIES.indexOf(q) !== -1) return q;
    var hub = hubOf(href);
    var s = hub ? seriesFromText(text) : null;
    return s && HUB_OF[s] === hub ? s : null;
  }
  /* Where a click on a plain hub link goes: the same hub with ?series= (and &body= when given) added, any other hash
     kept. A #series= / #body= fragment moves into the query (the fragment is dropped). Links that already carry
     ?series= and links that are not hubs are left alone. */
  function seriesHref(href, series, body) {
    var u = href ? urlOf(href) : null;
    if (!u || !hubOf(href) || SERIES.indexOf(series) === -1 || HUB_OF[series] !== hubOf(href) || u.searchParams.has('series')) return href;
    var hp = hashParams(u);
    if (!body && hp.get('body')) body = hp.get('body');
    if (hp.has('series')) u.hash = '';
    u.searchParams.set('series', series);
    if (body === 'sedan' || body === 'ute' || body === 'wagon') u.searchParams.set('body', body);
    var abs = /^[a-z]+:\/\//i.test(href);
    return (abs ? u.origin : '') + u.pathname + u.search + u.hash;
  }

  /* Product links that stand for one configuration (fitment page: Front pair, Full set …) are plain /products/<handle>
     URLs with data-fx-variant; ?variant= is added only for the click. */
  function variantHref(href, id) {
    if (!href || !/^\d+$/.test(String(id || ''))) return href;
    var u = urlOf(href);
    if (!u || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/.test(u.pathname) || u.searchParams.has('variant')) return href;
    u.searchParams.set('variant', String(id));
    return (/^[a-z]+:\/\//i.test(href) ? u.origin : '') + u.pathname + u.search + u.hash;
  }

  if (typeof module === 'object' && module && module.exports) module.exports = { isCardHref: isCardHref, isCardSection: isCardSection, applyDefaults: applyDefaults, restoreStates: restoreStates, hubOf: hubOf, paramOf: paramOf, seriesFromText: seriesFromText, seriesOfLink: seriesOfLink, seriesHref: seriesHref, variantHref: variantHref };
  if (typeof document === 'undefined') return;

  function api() { return window.FalcxVehicle || null; }
  function sized(url, w) {
    if (!url) return '';
    return /([?&])width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }

  /* Menu links that name a series become image cards, whatever their parent menu item is called. */
  function hrefsOf(list) {
    return Array.prototype.map.call(list.querySelectorAll('a[href]'), function (x) { return x.getAttribute('href'); });
  }
  function cards(panel) {
    var a = api();
    panel.querySelectorAll('.menu-drawer__menu--childlist').forEach(function (list) {
      /* r8: any list of collection links is a card list (Horizon only marks the two by handle). */
      if (isCardSection(hrefsOf(list))) {
        list.classList.add('falcx-nav-mobile', 'menu-drawer__menu--grid');
        list.querySelectorAll('img.menu-drawer__link-image').forEach(function (i) { i.classList.add('falcx-nav-image'); });
      }
      var links = Array.prototype.slice.call(list.querySelectorAll('a[href*="series="]'));
      /* r9: plain hub links whose title names a series are series cards too. */
      Array.prototype.forEach.call(list.querySelectorAll('a[href]'), function (x) {
        if (links.indexOf(x) === -1 && !/series=/.test(x.getAttribute('href') || '') && seriesOfLink(x.getAttribute('href'), x.textContent)) links.push(x);
      });
      if (!links.length) return;
      list.classList.add('falcx-nav-mobile', 'menu-drawer__menu--grid');
      links.forEach(function (link) {
        var series = seriesOfLink(link.getAttribute('href'), link.textContent);
        if (series && link.setAttribute) link.setAttribute('data-fx-series', series);
        if (link.querySelector('img') || !a || !a.resolve) return;
        var lh = link.getAttribute('href');
        var v = series ? a.resolve({ series: series, body: paramOf(lh, 'body') || 'sedan' }) : null;
        if (!v || !v.image) return;
        var img = new Image();
        img.alt = ''; img.decoding = 'async'; img.loading = 'lazy';
        img.className = 'menu-drawer__link-image falcx-nav-image falcx-nav-image--vehicle';
        img.srcset = sized(v.image, 240) + ' 240w, ' + sized(v.image, 360) + ' 360w, ' + sized(v.image, 480) + ' 480w';
        img.sizes = '(min-width: 750px) 200px, 45vw';
        img.src = sized(v.image, 360);
        link.insertBefore(img, link.firstChild);
      });
    });
  }

  /* "Saved" mark on the card of the remembered series. */
  function renderMine(panel) {
    var a = api();
    var v = a && a.getSaved ? a.getSaved() : null;
    panel.querySelectorAll('.falcx-nav-mobile a[href]').forEach(function (card) {
      var series = seriesOfLink(card.getAttribute('href'), card.getAttribute('data-fx-series') ? '' : card.textContent) || card.getAttribute('data-fx-series');
      if (!series) return;
      var on = !!v && series === v.series;
      card.classList.toggle('is-mine', on);
      var tag = card.querySelector('.falcx-drawer__tag');
      if (on && !tag) { tag = el('span', 'falcx-drawer__tag', 'Saved'); var txt = card.querySelector('.menu-drawer__menu-item-text'); (txt || card).appendChild(tag); }
      else if (!on && tag) tag.remove();
    });
  }

  /* The drawer's top-level accordions (Horizon's accordion-custom > details), with their child links. */
  function sectionsOf(panel) {
    return Array.prototype.map.call(panel.querySelectorAll('.menu-drawer__navigation accordion-custom > details'), function (d) {
      var list = d.querySelector('.menu-drawer__menu--childlist');
      return { details: d, hrefs: list ? hrefsOf(list) : [] };
    });
  }
  function syncExpanded(d) {
    var s = d && d.querySelector(':scope > summary');
    if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
  }
  /* Card-section heading: decorative "Show"/"Hide" pill with a chevron (aria-hidden). */
  function toggles(panel) {
    sectionsOf(panel).forEach(function (s) {
      var summary = s.details.querySelector(':scope > summary');
      if (!summary) return;
      /* Horizon never puts a name on these; a shared name would make them one-open-at-a-time. */
      if (s.details.hasAttribute('name')) s.details.removeAttribute('name');
      var card = isCardSection(s.hrefs);
      s.details.classList.toggle('falcx-drawer__section', card);
      if (card && !summary.querySelector('.falcx-drawer__toggle')) {
        var t = el('span', 'falcx-drawer__toggle');
        t.setAttribute('aria-hidden', 'true');
        t.appendChild(el('span', 'falcx-drawer__toggle-show', 'Show'));
        t.appendChild(el('span', 'falcx-drawer__toggle-hide', 'Hide'));
        summary.appendChild(t);
      }
      syncExpanded(s.details);
    });
  }
  /* Every open starts the same: card sections expanded, others collapsed, scrolled to the top. */
  function reset(drawer) {
    var panel = drawer && drawer.querySelector('.menu-drawer');
    if (!panel) return;
    applyDefaults(sectionsOf(panel));
    sectionsOf(panel).forEach(function (s) { syncExpanded(s.details); });
    remember(panel);
    panel.scrollTop = 0;
  }
  /* Open/closed state of each section while the drawer is open, so it survives a header morph (see watch()). */
  var states = [];
  function remember(panel) { states = sectionsOf(panel).map(function (s) { return !!s.details.open; }); }

  /* r8 sweep: Horizon's header morph (morph.js) runs about a second after load, often after the first tap on the menu
     button, and strips the falcx-drawer class, head, cards and open sections. Re-enhance, keeping the visitor's sections. */
  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  var pending = false;
  function rewatch() {
    pending = false;
    document.querySelectorAll('header-drawer').forEach(function (hd) {
      var panel = hd.querySelector('.menu-drawer');
      if (!panel || panel.classList.contains('falcx-drawer')) return;
      enhance(hd);
      var container = hd.querySelector('.menu-drawer-container');
      if (container && container.open) {
        var list = sectionsOf(panel);
        restoreStates(list, states);
        list.forEach(function (s) { syncExpanded(s.details); });
      }
    });
  }
  function watch(panel) {
    if (!watched || watched.has(panel) || typeof MutationObserver !== 'function') return;
    watched.add(panel);
    new MutationObserver(function () {
      if (pending || panel.classList.contains('falcx-drawer')) return;
      pending = true;
      setTimeout(rewatch, 0);
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  function enhance(drawer) {
    if (!drawer) return;
    var panel = drawer.querySelector('.menu-drawer');
    if (!panel) return;
    panel.classList.add('falcx-drawer');
    watch(panel);
    cards(panel);
    toggles(panel);
    if (panel.querySelector(':scope > .falcx-drawer__head')) return;

    var close = panel.querySelector(':scope > .menu-drawer__close-button');
    var head = el('div', 'falcx-drawer__head');
    var logo = el('a', 'falcx-drawer__logo');
    logo.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var headerLogo = document.querySelector('.header-logo img, .header__logo img');
    if (headerLogo) {
      var img = new Image();
      img.src = headerLogo.currentSrc || headerLogo.src;
      img.alt = (headerLogo.alt || 'FalcX') + ' home';
      img.height = 22; img.width = Math.round(22 * ((headerLogo.naturalWidth || 119) / (headerLogo.naturalHeight || 28)));
      logo.appendChild(img);
    } else {
      logo.textContent = 'FalcX';
    }
    head.appendChild(logo);
    if (close) close.insertAdjacentElement('afterend', head); else panel.insertBefore(head, panel.firstChild);

    /* The compact vehicle line: a copy of the header's, so falcx-finder.js fills and wires it like any other. */
    var chip = document.querySelector('.falcx-vchip--bar');
    if (chip) {
      var mine = chip.cloneNode(true);
      mine.className = 'falcx-vchip falcx-vchip--drawer';
      head.insertAdjacentElement('afterend', mine);
    }

    /* "EA–ED · 1988–1994" -> bold series + muted years. */
    panel.querySelectorAll('.falcx-nav-mobile .menu-drawer__menu-item-text').forEach(function (t) {
      var parts = t.textContent.trim().split(/\s+·\s+/);
      if (parts.length !== 2) return;
      t.textContent = '';
      t.appendChild(el('strong', '', parts[0]));
      t.appendChild(el('span', 'falcx-drawer__years', parts[1]));
      t.classList.add('falcx-drawer__card-text');
    });

    var tpl = document.getElementById('falcx-drawer-extras');
    if (tpl && tpl.content && !panel.querySelector('.falcx-drawer__foot')) panel.appendChild(tpl.content.cloneNode(true));
    var count = panel.querySelector('[data-falcx-cart-count]');
    if (count) setCount(parseInt(count.textContent, 10));
    renderMine(panel);
    var a = api();
    if (a && a.render) a.render();
  }

  function setCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    document.querySelectorAll('[data-falcx-cart-count]').forEach(function (c) { c.textContent = String(n); c.hidden = n < 1; });
    document.querySelectorAll('[data-falcx-cart-link]').forEach(function (l) { l.setAttribute('aria-label', n > 0 ? 'Cart, ' + n + (n === 1 ? ' item' : ' items') : 'Cart'); });
  }

  /* r9: desktop mega menu. Each series link gets data-fx-series and its car picture (--fx-nav-car): the saved body
     style's image for the saved series, else the sedan. Card styling for plain hub links is in falcx-shop-by-car. */
  function tagMega() {
    var a = api();
    var saved = a && a.getSaved ? a.getSaved() : null;
    document.querySelectorAll('.mega-menu__link[href]').forEach(function (link) {
      var series = seriesOfLink(link.getAttribute('href'), link.textContent);
      if (!series) return;
      if (link.getAttribute('data-fx-series') !== series) link.setAttribute('data-fx-series', series);
      var v = a && a.resolve ? a.resolve({ series: series, body: saved && saved.series === series ? saved.body : 'sedan' }) : null;
      if (v && v.image) link.style.setProperty('--fx-nav-car', 'url("' + sized(v.image, 480) + '")');
    });
  }
  /* r9: a click on a series link that is a plain hub URL opens the hub on that series. The link's href changes only for
     this click and is put back straight after, so the page never shows a parameter URL. Links elsewhere on the page can
     ask for the same with data-fx-series (and data-fx-body), and product links with data-fx-variant. */
  function onSeriesClick(e) {
    if (e.defaultPrevented || (e.button && e.button !== 1)) return;
    var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!link) return;
    var href = link.getAttribute('href');
    if (link.hasAttribute('data-fx-variant')) {
      var withVariant = variantHref(href, link.getAttribute('data-fx-variant'));
      if (withVariant !== href) {
        link.setAttribute('href', withVariant);
        setTimeout(function () { if (link.getAttribute('href') === withVariant) link.setAttribute('href', href); }, 0);
      }
      return;
    }
    var named = link.getAttribute('data-fx-series');
    var inMenu = link.closest('.mega-menu, .menu-drawer, header-drawer, .falcx-vbar');
    /* r2 follow-up (13 Oct 2026): store menu links carry ?series=…&body=sedan (store data, not theme). An explicit body=
       in an address now always wins (falcx-finder.js), so for this click a menu link carries the series only; the next
       page opens on the browsed or saved body style for that series, else the sedan. The href is put back straight after
       (the card pictures in falcx-shop-by-car key on it). A ute or wagon in a menu link is kept. */
    if (inMenu) {
      var mu = urlOf(href);
      if (mu && mu.searchParams.has('series') && String(mu.searchParams.get('body') || '').toLowerCase() === 'sedan') {
        mu.searchParams.delete('body');
        var bare = (/^[a-z]+:\/\//i.test(href) ? mu.origin : '') + mu.pathname + mu.search + mu.hash;
        link.setAttribute('href', bare);
        setTimeout(function () { if (link.getAttribute('href') === bare) link.setAttribute('href', href); }, 0);
        return;
      }
    }
    /* A hub link with #series= is converted wherever it is on the page; title-only series only inside the menus. */
    var fromHash = hubOf(href) ? String(hashParams(urlOf(href)).get('series') || '').toLowerCase().replace(/^fg-x$/, 'fgx') : '';
    var series = named || (SERIES.indexOf(fromHash) !== -1 ? fromHash : null) || (inMenu ? seriesOfLink(href, link.textContent) : null);
    if (!series) return;
    var next = seriesHref(href, series, link.getAttribute('data-fx-body'));
    if (next === href) return;
    link.setAttribute('href', next);
    setTimeout(function () { if (link.getAttribute('href') === next) link.setAttribute('href', href); }, 0);
  }
  document.addEventListener('click', onSeriesClick, true);
  document.addEventListener('auxclick', onSeriesClick, true);
  var megaTimer = null;
  function tagMegaSoon() { if (megaTimer) return; megaTimer = setTimeout(function () { megaTimer = null; tagMega(); }, 0); }
  /* Horizon re-renders the header after load: tag again when a pointer or focus reaches an untagged series link. */
  ['pointerover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var link = e.target && e.target.closest ? e.target.closest('.mega-menu__link, .menu-list__link') : null;
      if (link) tagMegaSoon();
    }, true);
  });
  document.addEventListener('falcx:vehicle-change', tagMegaSoon);

  function init() { document.querySelectorAll('header-drawer').forEach(enhance); tagMega(); }
  var opening = null; /* the drawer the menu button's click has just reset, so its toggle does not reset it again */
  /* Also enhance at the moment it opens: the menu button's click (capture, before Horizon opens it), toggle as fallback. */
  document.addEventListener('click', function (e) {
    var button = e.target && e.target.closest ? e.target.closest('.header__icon--menu') : null;
    if (button) {
      var hd = button.closest('header-drawer');
      var container = button.closest('details');
      enhance(hd);
      /* About to open: set the default sections first, so they are expanded when the panel slides in. */
      if (container && !container.open) { reset(hd); opening = container; }
    }
    /* "Change" in the drawer opens the vehicle dialog: close the drawer first (focus trap, scroll lock). */
    var change = e.target && e.target.closest ? e.target.closest('.falcx-drawer [data-vehicle-change]') : null;
    if (change && document.querySelector('[data-vehicle-dialog]')) {
      var close = change.closest('.falcx-drawer').querySelector(':scope > .menu-drawer__close-button');
      if (close) close.click();
    }
  }, true);
  /* Opened by something other than the menu button's click (e.g. script): the same default state. */
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    /* A section heading inside the drawer: keep aria-expanded truthful (Horizon's Esc sets it to false and never back). */
    if (t.tagName === 'DETAILS' && !t.classList.contains('menu-drawer-container') && t.closest && t.closest('.falcx-drawer')) {
      syncExpanded(t);
      var p = t.closest('.falcx-drawer');
      var c = p.closest('.menu-drawer-container');
      if (c && c.open) remember(p);
      return;
    }
    if (!t.classList.contains('menu-drawer-container')) return;
    if (t.open) {
      var hd = t.closest('header-drawer');
      enhance(hd);
      if (opening !== t) reset(hd);
      opening = null;
      return;
    }
    /* Closed with focus on the page body or left inside the hidden panel: give it back to the menu button. */
    setTimeout(function () {
      var button = t.querySelector(':scope > summary');
      var active = document.activeElement;
      if (button && (!active || active === document.body || (t.querySelector('.menu-drawer') || t).contains(active) && active !== button)) button.focus({ preventScroll: true });
    }, 0);
  }, true);
  /* Esc anywhere in the panel closes the drawer with its own close button (Horizon's keyup would only collapse the
     nearest section); the toggle handler above returns focus to the menu button. */
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    var t = e.target;
    var panel = t && t.closest ? t.closest('.falcx-drawer') : null;
    if (!panel) return;
    var container = panel.closest('.menu-drawer-container');
    var close = panel.querySelector(':scope > .menu-drawer__close-button');
    if (!container || !container.open || !close) return;
    e.stopPropagation();
    close.click();
  }, true);
  document.addEventListener('falcx:vehicle-change', function () { document.querySelectorAll('.falcx-drawer').forEach(renderMine); });
  /* Horizon fires cart:update after an add or change; keep the drawer's cart count in step. */
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail || {};
    var n = d.data && typeof d.data.itemCount === 'number' ? d.data.itemCount : d.resource && typeof d.resource.item_count === 'number' ? d.resource.item_count : NaN;
    setCount(n);
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();